import {ISeoPage} from "../types/types";

export function ensureOpenSooqBrand (seoPage: ISeoPage, lang: string): ISeoPage {
  let brands = ["opensooq", "السوق المفتوح", "السوقالمفتوح", "__site_name__"];
  let OpenSooqBrand = lang == "ar" ? "السوق المفتوح" : "OpenSooq" ;

  if (process.env.NEXT_PUBLIC_CUSTOM_THEME === "shobiddak") {
    brands = ["shobiddak", "شوبدك", "شو بدك"];
    OpenSooqBrand = lang == "ar" ? "شو بدك" : "ShoBiddak";
  }

  const pageTitle: String = seoPage.pageTitle.toLowerCase().replaceAll(' ', '');

  if (brands.some(keyword => pageTitle.includes(keyword))) {
    return seoPage;
  }
  seoPage.pageTitle += ` | ${OpenSooqBrand}` ;

  return seoPage;
};